import { render, staticRenderFns } from "./Estagiarios.vue?vue&type=template&id=33f53aea&scoped=true"
import script from "./Estagiarios.vue?vue&type=script&lang=js"
export * from "./Estagiarios.vue?vue&type=script&lang=js"
import style0 from "./Estagiarios.vue?vue&type=style&index=0&id=33f53aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f53aea",
  null
  
)

export default component.exports